import { z } from 'zod';
import { CursorPagination } from './common.js';
/** Group-expansion loop: scored candidates → paced joins → evaluation. */
export const JoinPlanStatus = z.enum([
    'candidate', 'approved', 'joining', 'joined', 'kept', 'left', 'rejected', 'blacklisted', 'failed',
]);
export const JoinPlanSummary = z.object({
    id: z.string().uuid(),
    chatId: z.string().uuid(),
    chat: z.object({
        title: z.string().nullable(),
        username: z.string().nullable(),
        inviteHash: z.string().nullable(),
        kind: z.string(),
        membersCount: z.number().int().nullable(),
        link: z.string().nullable(),
        discoveredCount: z.number().int(),
        depth: z.number().int(),
    }),
    status: JoinPlanStatus,
    score: z.number(),
    scoreJson: z.record(z.unknown()),
    decidedBy: z.enum(['auto', 'operator']).nullable(),
    pinned: z.boolean(),
    purpose: z.enum(['expand', 'coverage']),
    targetObservers: z.number().int().nullable(),
    assignedAccounts: z.array(z.object({ id: z.string().uuid(), phone: z.string() })),
    groupIds: z.array(z.string().uuid()),
    joinAttempts: z.number().int(),
    lastError: z.string().nullable(),
    approvedAt: z.string().datetime().nullable(),
    joinedAt: z.string().datetime().nullable(),
    evaluateAt: z.string().datetime().nullable(),
    evaluationJson: z.record(z.unknown()).nullable(),
    note: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ListJoinPlansQuery = CursorPagination.extend({
    status: JoinPlanStatus.optional(),
    q: z.string().max(128).optional(),
});
export const ExpansionStats = z.object({
    enabled: z.boolean(),
    mode: z.enum(['auto', 'manual']),
    byStatus: z.record(z.number().int()),
    joinsToday: z.number().int(),
    globalDailyJoins: z.number().int(),
    /** Observer accounts that still have join budget today. */
    accountsWithBudget: z.number().int(),
    observersTotal: z.number().int(),
    nextTickAt: z.string().datetime().nullable(),
    lastTickAt: z.string().datetime().nullable(),
    lastTickSummary: z.record(z.unknown()).nullable(),
});
/** Operator override on one plan (or on a raw tg_chats id → creates the plan). */
export const JoinPlanDecisionRequest = z.object({
    action: z.enum(['approve', 'pin', 'reject', 'blacklist', 'leave', 'reset']),
    note: z.string().max(500).optional(),
});
export const ExpansionRunResponse = z.object({
    scored: z.number().int(),
    /** Coverage plans created/refreshed for under-observed monitored groups. */
    coverage: z.number().int(),
    promoted: z.number().int(),
    joined: z.number().int(),
    pending: z.number().int(),
    failed: z.number().int(),
    evaluated: z.number().int(),
    kept: z.number().int(),
    left: z.number().int(),
    skippedReason: z.string().nullable(),
});
//# sourceMappingURL=expansion.js.map